import React from 'react';

const SvgConfigurationActive = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_572_3195)">
        <path
          d="M21.3333 4H2.66666C2.31304 4 1.9739 4.14048 1.72385 4.39052C1.4738 4.64057 1.33333 4.97971 1.33333 5.33333V18.6667C1.33333 19.0203 1.4738 19.3594 1.72385 19.6095C1.9739 19.8595 2.31304 20 2.66666 20H21.3333C21.687 20 22.0261 19.8595 22.2761 19.6095C22.5262 19.3594 22.6667 19.0203 22.6667 18.6667V5.33333C22.6667 4.97971 22.5262 4.64057 22.2761 4.39052C22.0261 4.14048 21.687 4 21.3333 4ZM21.3333 18.6667H2.66666V5.33333H21.3333V18.6667Z"
          fill="#0081FF"
        />
        <path
          d="M5.99999 9.33333H18C18.1768 9.33333 18.3464 9.2631 18.4714 9.13807C18.5964 9.01305 18.6667 8.84348 18.6667 8.66667C18.6667 8.48986 18.5964 8.32029 18.4714 8.19526C18.3464 8.07024 18.1768 8 18 8H5.99999C5.82318 8 5.65361 8.07024 5.52859 8.19526C5.40357 8.32029 5.33333 8.48986 5.33333 8.66667C5.33333 8.84348 5.40357 9.01305 5.52859 9.13807C5.65361 9.2631 5.82318 9.33333 5.99999 9.33333Z"
          fill="#0081FF"
        />
        <path
          d="M5.99999 12H18C18.1768 12 18.3464 11.9298 18.4714 11.8047C18.5964 11.6797 18.6667 11.5101 18.6667 11.3333C18.6667 11.1565 18.5964 10.987 18.4714 10.8619C18.3464 10.7369 18.1768 10.6667 18 10.6667H5.99999C5.82318 10.6667 5.65361 10.7369 5.52859 10.8619C5.40357 10.987 5.33333 11.1565 5.33333 11.3333C5.33333 11.5101 5.40357 11.6797 5.52859 11.8047C5.65361 11.9298 5.82318 12 5.99999 12Z"
          fill="#0081FF"
        />
        <path
          d="M5.99999 14.6667H12.6667C12.8435 14.6667 13.013 14.5964 13.1381 14.4714C13.2631 14.3464 13.3333 14.1768 13.3333 14C13.3333 13.8232 13.2631 13.6536 13.1381 13.5286C13.013 13.4036 12.8435 13.3333 12.6667 13.3333H5.99999C5.82318 13.3333 5.65361 13.4036 5.52859 13.5286C5.40357 13.6536 5.33333 13.8232 5.33333 14C5.33333 14.1768 5.40357 14.3464 5.52859 14.4714C5.65361 14.5964 5.82318 14.6667 5.99999 14.6667Z"
          fill="#0081FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_572_3195">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgConfigurationActive;
